import { GROWTHSAYER_BLUE } from "./colors";

export const ProgressBar = ({ currentSize, estimatedSize, startTime }) => {
  if (!estimatedSize || !currentSize) return null;

  const downloadPercent = Math.min(100, Math.round((currentSize / estimatedSize) * 100));
  const actualPercent = Math.round(downloadPercent - (downloadPercent * 0.1));
  const duration = (Date.now() - startTime) / 1000;
  const rate = currentSize / duration;
  const totalEstimatedTime = estimatedSize / rate;

  let eta = null;
  if (totalEstimatedTime > 1) {
    const remaining = (estimatedSize - currentSize) / rate;
    const minutes = Math.floor(remaining / 60);
    const seconds = Math.round(remaining % 60);
    eta = `Downloading before processing... • ETA ~ ${minutes > 0 ? `${minutes}m ` : ''}${seconds}s`;
  }

  return (
    <div style={{ width: '100%', marginTop: '8px' }}>
      <div
        style={{
          height: '6px',
          width: '100%',
          backgroundColor: actualPercent < 100 ? '#e0e0e0' : GROWTHSAYER_BLUE,
          borderRadius: '3px',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${actualPercent}%`,
            height: '100%',
            backgroundColor: GROWTHSAYER_BLUE,
            transition: 'width 0.2s ease-out',
          }}
        />
      </div>
      <div style={{ marginTop: '4px', fontSize: '12px', textAlign: 'right', color: '#555' }}>
        {actualPercent}% complete {downloadPercent < 100 ? eta && ` • ${eta}` : ` • Download complete • Processing data...`}
      </div>
    </div>
  );
};
